import { Locale } from 'modules/i18n';

export const metaTranslation = {
  [Locale.en]: {
    '/': {
      title:
        'Free Blockchain RPC Endpoints for {chainsCount, number}+ Networks: Ankr Chainlist',
      description:
        "Access {chainsCount, number}+ blockchains via Ankr Chainlist's RPC endpoints. Optimize crypto projects seamlessly. Start testing our RPC now for free!",
      keywords: 'Free RPC, RPC, Chainlist, RPC Crypto',
    },
    '/sei': {
      title:
        '[Sei Dedicated RPC] Freemium Plan Available! Connect With {chainsCount, number}+ Crypto RPCs',
      description:
        'Explore the world of blockchain with SEI RPC Freemium plan. Connect to {chainsCount, number}+ Crypto RPCs. Freemium and premium plans available to suit your needs. Start now!',
      keywords: 'Sei RPC, Sei RPC Free',
    },
    '/solana': {
      title:
        '[Solana Dedicated RPC] Freemium Plan Available! Connect With {chainsCount, number}+ Crypto RPCs',
      description:
        'Explore the world of blockchain with SOLANA RPC Freemium plan. Connect to {chainsCount, number}+ Crypto RPCs. Freemium and premium plans available to suit your needs. Start now!',
      keywords: 'Solana RPC, Solana RPC Free',
    },
  },
};
